<template>
  <div class="success-message">
    <span class="success-message__text"> {{ text }} </span>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";

defineProps({
  text: {
    type: String as PropType<string>,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.success-message {
  display: inline-flex;
  align-items: center;
  background: $color-success-light;
  border: 0.1rem solid $color-success;
  border-radius: 0.5rem;
  padding: 1rem;

  &__text {
    margin-left: 0.5rem;
    font-weight: 400;
    font-size: $font-size-base;
    line-height: 1.25;
  }
}
</style>
